import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import HotResources from './components/HotResources';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" />
      <SchemaOrg type="FAQPage" />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedArticles />
          <HotResources />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}